export type AppEnv = 'prod' | 'stage' | 'local';

export const APP_ENV: AppEnv = 'stage';
export const APP_VERSION = '1.0.0';
export const RELEASE_NOTES = {
  id: '1.0.0',
  title: '',
  body: '',
  show: false,
};
